import CustodyScanForm, { type CustodyFormConfig, type CustodyRow } from './CustodyScanForm';
import { type AppColumn } from '../../components/AppDataGrid';
import { fmtLocalDate } from '../../utils/datetime';

// Sample Out — scan a bottle that's currently "In"; it moves FROM its storage
// location TO the current user. No "To" picker (ALPACA parity). 7-col grid from
// the prototype: SampleBottleID · From · To · DateHandled · HandledBy · Mode · Hazardous.
const COLUMNS: AppColumn<CustodyRow>[] = [
  { field: 'bottle',    header: 'SampleBottleID', width: 170 },
  { field: 'from',      header: 'From',           width: 150 },
  { field: 'to',        header: 'To',             width: 130 },
  { field: 'scannedAt', header: 'DateHandled',    width: 160, text: r => fmtLocalDate(r.scannedAt) },   // date-only (ALPACA parity, §14b.6)
  { field: 'by',        header: 'HandledBy',      width: 130 },
  { field: 'mode',      header: 'Mode', width: 90, render: r => <span className="bl-pill info">{r.mode}</span>, text: r => r.mode },
  { field: 'haz',       header: 'Hazardous', width: 100,
    render: r => <input type="checkbox" checked={r.haz} disabled readOnly />,
    text: r => (r.haz ? 'Yes' : 'No') },
];

const CONFIG: CustodyFormConfig = {
  pageId:         'sample-out',
  exportFilename: 'SampleOut',
  breadcrumbLeaf: 'Sample Out',
  subtitle:       'Scan bottle barcodes to check them out',
  actionLabel:    'Save',
  confirmTitle:   'Save',
  confirmMessage: 'Do you want to Save?',
  successVerb:    'Saved',
  formName:       'Sample Out',
  columns:        COLUMNS,
  resolveUrl:     '/api/v1/sample-custody/resolve-out',
  saveUrl:        '/api/v1/sample-custody/sample-out',
  emptyPrompt:    'No data to display — scan a barcode above.',
  initialSort:    { key: 'bottle', dir: 'asc' },   // SampleBottleID ascending (ALPACA parity)
  buildRow: (r, ctx) => ({
    id:             `${r.sampleBottleId}-${ctx.nowIso}-${Math.round(performance.now())}`,
    bottle:         r.sampleBottleId ?? '',
    from:           r.from ?? '',
    to:             ctx.userName,
    scannedAt:      ctx.nowIso,
    by:             ctx.userName,
    haz:            !!r.hazardous,
    mode:           'Out',
    deplete:        false,
    wasteDrum:      '',
    sampleLoginOid: r.sampleLoginOid ?? null,
    jobOid:         r.jobOid ?? null,
    client:         r.client ?? null,
  }),
  buildScan: (row) => ({
    sampleBottleId: row.bottle,
    sampleLoginOid: row.sampleLoginOid,
    jobOid:         row.jobOid,
    client:         row.client,
  }),
};

export default function SampleOutPage() {
  return <CustodyScanForm config={CONFIG} />;
}
